import { Loader } from "@/components/collection"
import { PageHeader, PageWrapper } from "@/components/layout/dashboard"
import { usePromise } from "@/hooks/usePromise"
import { SelectProvider, useSelect } from "@/hooks/useSelect"
import { getArticleCategories } from "@/store/articles/actions"
import Collection from "./Collection"
import { Context, ContextProvider } from "./Context"

/**
 * dictionary src/dictionaries/en/pages/dashboard/articles.json
 */
const dictionary = createContextMapper("pages", "dashboard", "articles")

/**
 * Page: ArticlesCategories
 */
const ArticlesCategories: React.FC = () => {
  const { _ } = useDictionary(dictionary())
  const select = useSelect(Context)
  return (
    <PageWrapper ref={select.ref}>
      <SelectProvider {...select.props} />
      <PageHeader
        breadcrumbs={[
          [_("breadcrumbs"), "/dashboard/articles"],
          [_("categories.breadcrumbs"), "/dashboard/articles/categories"],
        ]}
      />
      <Collection />
    </PageWrapper>
  )
}
export default () => {
  const { _ } = useDictionary(dictionary())
  const [, inProgress] = usePromise(getArticleCategories)
  if (inProgress) return <Loader breadcrumbs={[[_("breadcrumbs"), "/dashboard/articles"]]} />
  return (
    <ContextProvider>
      <ArticlesCategories />
    </ContextProvider>
  )
}
